import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import services from "../services";
import withMessage from "./withMessage";
import withResponseHandling from "./withResponseHandling";
import { acReportsEnquadramentosChanged } from "../store/actions";
import useAuth from "../hooks/useAuth";
const PAGE_SIZE = 25;
const withCenarios = (Component, options = {
  readCenariosParams: {}
}) => {
  function WrapComponent(props) {
    const storeDispatch = useDispatch();
    const {
      isAuthorized
    } = useAuth();
    const reportsUpdatedAt = useSelector(state => state.background.reports.updatedAt);
    const entidadeId = useSelector(state => state.entidade.current.default_entidade_id);
    const {
      output
    } = useParams();
    const [cenarios, setCenarios] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [rowSelection, setRowSelection] = useState({});
    const [pagination, setPagination] = useState({
      pageIndex: 0,
      pageSize: PAGE_SIZE
    });
    const [columnFilters, setColumnFilters] = useState([]);
    const [sorting, setSorting] = useState([]);
    const [globalFilter, setGlobalFilter] = useState("");
    function formatColumnFilters(pColumnFilters = []) {
      const xFilters = {};
      pColumnFilters.forEach(xItem => {
        xFilters[xItem.id] = xItem.value;
      });
      return xFilters;
    }
    const readCenarios = useCallback((pParams = {}) => {
      if (!cenarios.length) {
        setIsLoading(true);
      } else {
        setIsRefetching(true);
      }
      const xParams = {
        size: PAGE_SIZE,
        page: 1,
        ...pParams
      };
      services.cenarios.list(xParams, rRes => {
        const xCenarios = Object.values(rRes.data);
        setCenarios(xCenarios);
        setRowCount(rRes?.pages?.total_items);
        storeDispatch(acReportsEnquadramentosChanged(xCenarios));
      }, rErr => {
        props.responseErrorHandling(rErr);
      }, () => {
        setIsLoading(false);
        setIsRefetching(false);
      });
    }, [cenarios.length, output, props]);
    const deleteCenarios = (pData, onFinish) => {
      services.cenarios.remove(pData, rRes => {
        props.onMessageSuccess("Cenários excluído com sucesso");
        readCenarios();
        setRowSelection({});
      }, rErr => {
        props.responseErrorHandling(rErr);
      }, () => {
        onFinish && onFinish();
      });
    };
    const bulkDeleteCenarios = pRows => {
      const xCenariosId = pRows.map(xRow => {
        const {
          cenario_id,
          cenario
        } = xRow.original;
        return {
          cenario_id,
          cenario
        };
      });
      xCenariosId.forEach(xData => {
        deleteCenarios(xData);
      });
    };
    const favCenario = (pData = {}) => {
      services.cenarios.modify(pData, _rRes => {
        readCenarios();
      }, rErr => {
        props.responseErrorHandling(rErr);
      }, () => {});
    };
    useEffect(() => {
      const xPage = pagination.pageIndex + 1;
      const xFilters = formatColumnFilters(columnFilters);
      isAuthorized && readCenarios({
        page: xPage,
        size: pagination.pageSize,
        ...xFilters,
        ...options.readCenariosParams
      });
    }, [readCenarios, pagination.pageIndex, pagination.pageSize, reportsUpdatedAt, entidadeId, columnFilters, sorting, globalFilter, isAuthorized]);
    const xProps = {
      cenarios,
      isLoading,
      isRefetching,
      rowCount,
      pagination,
      sorting,
      columnFilters,
      rowSelection,
      setPagination,
      setRowSelection,
      setColumnFilters,
      setSorting,
      setGlobalFilter,
      readCenarios,
      deleteCenarios,
      bulkDeleteCenarios,
      favCenario
    };
    return <Component {...props} {...xProps} />;
  }
  return withMessage(withResponseHandling(WrapComponent));
};
export default withCenarios;
